import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ExternalCommunicationDialogComponent } from '@components/system-setting/external-communication-dialog/external-communication-dialog.component';
import { SlotDialogComponent } from '@components/system-setting/slot-dialog/slot-dialog.component';
import { defaultExternalCommunication, defaultSlotList, SystemSettingTab } from '@models/system-setting';
import { FcuUnitServiece } from '@service/fcu-unit.service';
import { FuUnitService } from '@service/fu-unit.service';
import { SlotService } from '@service/slot.service';
import { VesselService } from '@service/vessel.service';
import {
    FcuUnit,
    FcuUnitAliases,
    FcuUnitFull,
    FcuUnitNormalizer,
    getDefaultFcuData,
} from 'icreate/common/models/fcu-unit';
import { communicationTypes, fuMax, FuUnit, FuUnitWithUX } from 'icreate/common/models/fu-unit';
import {
    emptySlot,
    emptyValue,
    getFcuDefaultSlots,
    Slot,
    slotOptions,
    SlotOptionType,
} from 'icreate/common/models/slot';
import { Vessel } from 'icreate/common/models/vessel';
import { getValidationErrors, ValidationErrorMap } from 'icreate/common/validators';
import { addPrefixToErrors, mapErrors } from 'icreate/common/validators/custom-functions';
import { fcuUnitNetWorkValidator } from 'icreate/common/validators/fcu-unit-network/fcu-unit-network-validator';
import { fcuUnitValidator } from 'icreate/common/validators/fcu-unit/fcu-unit-validator';
import { fuUnitValidator } from 'icreate/common/validators/fu-unit/fu-unit-validator';
import { firstValueFrom } from 'rxjs';
import _ from 'lodash';
import { ExternalCommunicationService } from '@service/external-communication.service';
import { CeuUnitService } from '@service/ceu-unit.service';
import { CeuUnit } from 'icreate/common/models/ceu-unit';
import { ExternalCommunicationWithConfig } from 'icreate/common/models/external-communication';
import { MessageDialogService } from '@service/message-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { SlotDisplayService } from '@helpers/slot-display-utils';

export enum FcuInputName {
    fcuALineAIp = 'fcuALineAIp',
    fcuALineBIp = 'fcuALineBIp',
    fcuAFieldNetLineAIp = 'fcuAFieldNetLineAIp',
    fcuAFieldNetLineBIp = 'fcuAFieldNetLineBIp',
    fcuACeuCommLineAIp = 'fcuACeuCommLineAIp',
    fcuACeuCommLineBIp = 'fcuACeuCommLineBIp',
    fcuBLineAIp = 'fcuBLineAIp',
    fcuBLineBIp = 'fcuBLineBIp',
    fcuBFieldNetLineAIp = 'fcuBFieldNetLineAIp',
    fcuBFieldNetLineBIp = 'fcuBFieldNetLineBIp',
    fcuBCeuCommLineAIp = 'fcuBCeuCommLineAIp',
    fcuBCeuCommLineBIp = 'fcuBCeuCommLineBIp',
    multicastingLineAIp = 'multicastingLineAIp',
    multicastingLineBIp = 'multicastingLineBIp',
    location = 'location',
    slotCount = 'slotCount',
}

@Component({
    selector: 'app-fcu-setting',
    templateUrl: './fcu-setting.component.html',
    styleUrls: ['./fcu-setting.component.css'],
    standalone: false,
})
export class FcuSettingComponent implements OnInit, AfterViewInit {
    @ViewChild('moreOptions') moreOptions: ElementRef;
    @ViewChild('errorPopup') errorPopup!: ElementRef;
    @ViewChild('sideMenuContainer') sideMenuContainer: ElementRef;

    readonly EMPTY_VALUE = emptyValue;

    readonly FCU_A_LINE_A_IP = FcuInputName.fcuALineAIp;
    readonly FCU_A_LINE_B_IP = FcuInputName.fcuALineBIp;

    readonly FCU_A_FIELD_NET_A_IP = FcuInputName.fcuAFieldNetLineAIp;
    readonly FCU_A_FIELD_NET_B_IP = FcuInputName.fcuAFieldNetLineBIp;

    readonly FCU_A_CEU_COMM_A_IP = FcuInputName.fcuACeuCommLineAIp;
    readonly FCU_A_CEU_COMM_B_IP = FcuInputName.fcuACeuCommLineBIp;

    readonly FCU_B_LINE_A_IP = FcuInputName.fcuBLineAIp;
    readonly FCU_B_LINE_B_IP = FcuInputName.fcuBLineBIp;

    readonly FCU_B_FIELD_NET_A_IP = FcuInputName.fcuBFieldNetLineAIp;
    readonly FCU_B_FIELD_NET_B_IP = FcuInputName.fcuBFieldNetLineBIp;

    readonly FCU_B_CEU_COMM_A_IP = FcuInputName.fcuBCeuCommLineAIp;
    readonly FCU_B_CEU_COMM_B_IP = FcuInputName.fcuBCeuCommLineBIp;

    readonly LOCATION = FcuInputName.location;

    readonly FCU_SLOT_OPTIONS = slotOptions;
    readonly EMPTY_SLOT = emptySlot;

    readonly FU_MAX = fuMax;

    vessel: Vessel;
    selectedFcuUnit: FcuUnit = undefined;
    fcuUnitList: FcuUnit[] = [];
    fuList: FuUnitWithUX[] = [];
    selectedSlotCounter: number = 8;
    location: string = '';
    fcuALineAIp: string = '';
    fcuALineBIp: string = '';
    fcuAFieldNetLineAIp: string = '';
    fcuAFieldNetLineBIp: string = '';
    fcuACeuCommLineAIp: string = '';
    fcuACeuCommLineBIp: string = '';
    fcuBLineAIp: string = '';
    fcuBLineBIp: string = '';
    fcuBFieldNetLineAIp: string = '';
    fcuBFieldNetLineBIp: string = '';
    fcuBCeuCommLineAIp: string = '';
    fcuBCeuCommLineBIp: string = '';
    validationErrors: ValidationErrorMap = {};
    isOpenOption: boolean = false;
    externalCommunication: ExternalCommunicationWithConfig = defaultExternalCommunication;
    slotList: Slot[] = defaultSlotList;
    ceuList: CeuUnit[] = undefined;
    isLoading: boolean = true;
    errorMessageVisible: boolean = false;
    urlState: any;
    initState: FcuUnitNormalizer;
    contentHeight: string;

    constructor(
        private dialog: MatDialog,
        private fcuUnitService: FcuUnitServiece,
        private vesselService: VesselService,
        private router: Router,
        private route: ActivatedRoute,
        private slotService: SlotService,
        private fuUnitService: FuUnitService,
        private externalCommunicationService: ExternalCommunicationService,
        private ceuUnitService: CeuUnitService,
        private messageDialogService: MessageDialogService,
        private translateService: TranslateService,
        private cdr: ChangeDetectorRef,
        private slotDisplayService: SlotDisplayService
    ) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: MouseEvent) {
        if (this.isOpenOption && !this.moreOptions.nativeElement.contains(event.target)) {
            this.isOpenOption = false;
        }

        if (this.errorMessageVisible && !this.errorPopup?.nativeElement.contains(event.target)) {
            this.errorMessageVisible = false;
        }
    }

    @HostListener('window:resize')
    onWindowChange() {
        this.updateContentHeight();
    }

    async ngOnInit() {
        const vesselId = this.route.snapshot.params['vesselId'];
        const fcuId = this.route.snapshot.paramMap.get('fcuId');
        this.urlState = history.state;

        try {
            const currentVessel = await this.vesselService.getVessel(vesselId);
            if (!currentVessel) {
                this.router.navigateByUrl('home');
                return;
            }
            this.vesselService.setActiveVessel(currentVessel);
            this.vessel = currentVessel;

            this.fcuUnitList = await this.fcuUnitService.getList(this.vessel.id);

            if (fcuId) {
                const fcuUnitFull = await this.fcuUnitService.getFcuUnitFull(fcuId, [
                    FcuUnitAliases.fuUnits,
                    FcuUnitAliases.slots,
                    FcuUnitAliases.extComms,
                    FcuUnitAliases.ceuUnits,
                ]);
                this.initFcuUnitData(fcuUnitFull);
                this.initState = _.cloneDeep(this.buildComparableState());
            } else {
                this.initDefaultData();
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.isLoading = false;
            this.cdr.detectChanges();
            this.updateContentHeight();
        }
    }

    ngAfterViewInit(): void {
        this.updateContentHeight();
    }

    initFcuUnitData(fcuUnitFull: FcuUnitFull) {
        const { fcuUnit, slotList, fuUnitList, extComm, ceuUnitList } = fcuUnitFull;

        if (fcuUnit) {
            this.selectedFcuUnit = {
                id: fcuUnit.id,
                vesselId: fcuUnit.vesselId,
                location: fcuUnit.location,
                index: fcuUnit.index,
            };
            this.location = fcuUnit?.location;
            this.fcuALineAIp = fcuUnit?.network.A.LineAIp;
            this.fcuALineBIp = fcuUnit?.network.A.LineBIp;
            this.fcuAFieldNetLineAIp = fcuUnit?.network.A.fieldNetLineAIp;
            this.fcuAFieldNetLineBIp = fcuUnit?.network.A.fieldNetLineBIp;
            this.fcuACeuCommLineAIp = fcuUnit.network.A.ceuCommLineAIp;
            this.fcuACeuCommLineBIp = fcuUnit.network.A.ceuCommLineBIp;
            this.fcuBLineAIp = fcuUnit?.network.B.LineAIp;
            this.fcuBLineBIp = fcuUnit?.network.B.LineBIp;
            this.fcuBFieldNetLineAIp = fcuUnit?.network.B.fieldNetLineAIp;
            this.fcuBFieldNetLineBIp = fcuUnit?.network.B.fieldNetLineBIp;
            this.fcuBCeuCommLineAIp = fcuUnit.network.B.ceuCommLineAIp;
            this.fcuBCeuCommLineBIp = fcuUnit.network.B.ceuCommLineBIp;
        }

        if (slotList) {
            const { fcuSlotList, fuGroupSlotList } = this.splitSlots(slotList);

            this.slotList = fcuSlotList.map((slot: any) => ({
                ...slot,
                ioType: slot.ioType === this.EMPTY_VALUE ? this.EMPTY_SLOT : slot.ioType,
            }));

            this.fuList = fuUnitList
                .map(fuUnit => {
                    return {
                        ...fuUnit,
                        slotList: fuGroupSlotList[fuUnit.id].map((slot: any) => ({
                            ...slot,
                            ioType: slot.ioType === this.EMPTY_VALUE ? this.EMPTY_SLOT : slot.ioType,
                        })),
                    };
                })
                .sort((a, b) => a.index - b.index);
        }

        if (extComm) {
            this.externalCommunication = extComm[0];
        }
        if (ceuUnitList) {
            this.ceuList = ceuUnitList.sort((a, b) => a.index - b.index);
        }
    }

    getSlotValue(slot) {
        return this.slotDisplayService.getSlotValue(slot);
    }

    buildComparableState() {
        return {
            selectedFcuUnit: this.selectedFcuUnit,
            location: this.location,

            network: {
                fcuALineAIp: this.fcuALineAIp,
                fcuALineBIp: this.fcuALineBIp,
                fcuAFieldNetLineAIp: this.fcuAFieldNetLineAIp,
                fcuAFieldNetLineBIp: this.fcuAFieldNetLineBIp,
                fcuACeuCommLineAIp: this.fcuACeuCommLineAIp,
                fcuACeuCommLineBIp: this.fcuACeuCommLineBIp,
                fcuBLineAIp: this.fcuBLineAIp,
                fcuBLineBIp: this.fcuBLineBIp,
                fcuBFieldNetLineAIp: this.fcuBFieldNetLineAIp,
                fcuBFieldNetLineBIp: this.fcuBFieldNetLineBIp,
                fcuBCeuCommLineAIp: this.fcuBCeuCommLineAIp,
                fcuBCeuCommLineBIp: this.fcuBCeuCommLineBIp,
            },

            fuList: (this.fuList ?? [])
                .map(fu => ({
                    id: fu.id,
                    index: fu.index,
                    location: fu.location ?? null,
                    communicationType: fu.communicationType ?? null,
                    fcuId: fu.fcuId ?? null,
                    vesselId: fu.vesselId ?? null,
                    fieldNetLineAIp: fu.fieldNetLineAIp ?? null,
                    fieldNetLineBIp: fu.fieldNetLineBIp ?? null,
                    slotList: (fu.slotList ?? [])
                        .map(slot => ({
                            id: slot.id,
                            fcuId: slot.fcuId,
                            fuId: slot.fuId ?? null,
                            vesselId: slot.vesselId,
                            ioType: slot.ioType == this.EMPTY_SLOT || !slot.ioType ? this.EMPTY_VALUE : slot.ioType,
                            no: slot.no,
                            terminal: slot.terminal ?? [],
                            enable: slot.enable,
                        }))
                        .sort((a, b) => a.no - b.no),
                }))
                .sort((a, b) => a.index - b.index),

            slotList: (this.slotList ?? [])
                .map(slot => ({
                    id: slot.id,
                    fcuId: slot.fcuId,
                    fuId: slot.fuId ?? null,
                    vesselId: slot.vesselId,
                    ioType: slot.ioType,
                    no: slot.no,
                    terminal: slot.terminal ?? [],
                    enable: slot.enable,
                }))
                .sort((a, b) => a.no - b.no),

            externalCommunication: this.externalCommunication ?? null,

            ceuList: (this.ceuList ?? [])
                .map(ceu => ({
                    id: ceu.id,
                    index: ceu.index,
                    location: ceu.location ?? null,
                }))
                .sort((a, b) => a.index - b.index),
        };
    }

    initDefaultData() {
        const fcuIndex = this.fcuUnitList.length + 1;
        const defaultValues = getDefaultFcuData(fcuIndex, this.vessel.id);
        this.fcuALineAIp = defaultValues.network.A.LineAIp;
        this.fcuALineBIp = defaultValues.network.A.LineBIp;
        this.fcuAFieldNetLineAIp = defaultValues.network.A.fieldNetLineAIp;
        this.fcuAFieldNetLineBIp = defaultValues.network.A.fieldNetLineBIp;
        this.fcuACeuCommLineAIp = defaultValues.network.A.ceuCommLineAIp;
        this.fcuACeuCommLineBIp = defaultValues.network.A.ceuCommLineBIp;
        this.fcuBLineAIp = defaultValues.network.B.LineAIp;
        this.fcuBLineBIp = defaultValues.network.B.LineBIp;
        this.fcuBFieldNetLineAIp = defaultValues.network.B.fieldNetLineAIp;
        this.fcuBFieldNetLineBIp = defaultValues.network.B.fieldNetLineBIp;
        this.fcuBCeuCommLineAIp = defaultValues.network.B.ceuCommLineAIp;
        this.fcuBCeuCommLineBIp = defaultValues.network.B.ceuCommLineBIp;
        this.slotList = getFcuDefaultSlots(this.vessel.id);
    }

    splitSlots(selectedSlotList: Slot[]) {
        const fcuSlotList = selectedSlotList.filter(slot => slot.fuId == null).sort((a, b) => a.no - b.no);

        const fuGroupSlotList = selectedSlotList
            .filter(slot => slot.fuId != null)
            .sort((a, b) => a.no - b.no)
            .reduce(
                (prev, slot) => {
                    const key = String(slot.fuId);
                    (prev[key] ??= []).push(slot);
                    return prev;
                },
                {} as Record<string, Slot[]>
            );

        return { fcuSlotList, fuGroupSlotList };
    }

    inputChange(event: { name: string; value: string }) {
        const { name, value } = event;
        switch (name) {
            case FcuInputName.location:
                this.location = value;
                break;
            case FcuInputName.fcuALineAIp:
                this.fcuALineAIp = value;
                break;
            case FcuInputName.fcuALineBIp:
                this.fcuALineBIp = value;
                break;
            case FcuInputName.fcuAFieldNetLineAIp:
                this.fcuAFieldNetLineAIp = value;
                break;
            case FcuInputName.fcuAFieldNetLineBIp:
                this.fcuAFieldNetLineBIp = value;
                break;
            case FcuInputName.fcuACeuCommLineAIp:
                this.fcuACeuCommLineAIp = value;
                break;
            case FcuInputName.fcuACeuCommLineBIp:
                this.fcuACeuCommLineBIp = value;
                break;
            case FcuInputName.fcuBLineAIp:
                this.fcuBLineAIp = value;
                break;
            case FcuInputName.fcuBLineBIp:
                this.fcuBLineBIp = value;
                break;
            case FcuInputName.fcuBFieldNetLineAIp:
                this.fcuBFieldNetLineAIp = value;
                break;
            case FcuInputName.fcuBFieldNetLineBIp:
                this.fcuBFieldNetLineBIp = value;
                break;
            case FcuInputName.fcuBCeuCommLineAIp:
                this.fcuBCeuCommLineAIp = value;
                break;
            case FcuInputName.fcuBCeuCommLineBIp:
                this.fcuBCeuCommLineBIp = value;
                break;
        }

        this.checkInputErrors();
    }

    async createFcuUnit() {
        this.checkInputErrors();
        if (Object.keys(this.validationErrors).length) return;

        this.isLoading = true;
        try {
            let createdFcuUnit: FcuUnit | null = null;

            if (this.selectedFcuUnit) {
                await this.update();
            } else {
                createdFcuUnit = await this.create();
            }

            const updatedVessel = await this.vesselService.getVessel(this.vessel.id);
            await this.vesselService.updateVesselInList(updatedVessel);

            const fcuId = this.selectedFcuUnit ? this.selectedFcuUnit.id : createdFcuUnit?.id;
            await this.router.navigateByUrl(`${this.vessel.id}/fcu/${fcuId}/view`, {
                state: {
                    showMessage: true,
                    isNewFcu: !this.selectedFcuUnit,
                },
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.isLoading = false;
        }
    }

    async goBackSettingPage() {
        if (this.selectedFcuUnit && this.urlState?.origin == 'view') {
            await this.router.navigateByUrl(`${this.vessel.id}/fcu/${this.selectedFcuUnit.id}/view`);
        } else {
            await this.router.navigate([`home/${this.vessel.id}/settings/fcu`], {
                queryParams: { tab: SystemSettingTab.fcu },
            });
        }
    }

    async create() {
        const newFcuUnit = await this.fcuUnitService.create(this.createFcuUnitPayload());
        const newFuUnitList = await this.fuUnitService.create(
            this.createFuUnitsPayload(newFcuUnit.id),
            newFcuUnit.index
        );
        await this.slotService.create(
            this.createSlotsPayload(newFcuUnit.id, newFuUnitList ? newFuUnitList : []),
            newFcuUnit.index
        );
        // if (this.externalCommunication?.index) {
        //     await this.externalCommunicationService.create(this.createExtCommPayload(newFcuUnit.id));
        // }
        // if (this.ceuList && this.ceuList?.length !== 0) {
        //     await this.ceuUnitService.create(this.createCeuUnitsPayload(newFcuUnit.id), newFcuUnit.index);
        // }
        return newFcuUnit;
    }

    async update() {
        const updatedFcuUnit = await this.fcuUnitService.update(this.createFcuUnitPayload());

        const updatedFuUnitList = await this.fuUnitService.update(
            this.createFuUnitsPayload(updatedFcuUnit.id),
            updatedFcuUnit.id,
            updatedFcuUnit.index
        );

        await this.slotService.update(
            this.createSlotsPayload(updatedFcuUnit.id, updatedFuUnitList),
            updatedFcuUnit.index
        );

        if (this.externalCommunication?.index) {
            const extCommPayload = this.createExtCommPayload(updatedFcuUnit.id);
            if (extCommPayload.id) await this.externalCommunicationService.update(extCommPayload);
            else await this.externalCommunicationService.create(extCommPayload);
        }

        // await this.ceuUnitService.update(
        //     this.createCeuUnitsPayload(updatedFcuUnit.id),
        //     updatedFcuUnit.id,
        //     updatedFcuUnit.index
        // );

        await this.fcuUnitService.getUpdatedFcuUnitFull(this.selectedFcuUnit.id, [
            FcuUnitAliases.fuUnits,
            FcuUnitAliases.slots,
            FcuUnitAliases.extComms,
            FcuUnitAliases.ceuUnits,
        ]);
    }

    createFcuUnitMulticastingData() {
        let multicastingAIp = '';
        let multicastingBIp = '';

        if (this.fcuALineAIp) multicastingAIp = '239.255.255.250';
        else if (this.fcuBLineAIp) multicastingAIp = '239.255.255.250';

        if (this.fcuALineBIp) multicastingBIp = '239.255.255.250';
        else if (this.fcuBLineBIp) multicastingBIp = '239.255.255.250';

        return {
            multicastingAIp,
            multicastingBIp,
        };
    }

    createFcuUnitPayload() {
        const { multicastingAIp, multicastingBIp } = this.createFcuUnitMulticastingData();

        return {
            id: this.selectedFcuUnit?.id ? this.selectedFcuUnit?.id : '',
            location: this.location,
            vesselId: this.vessel.id,
            index: this.selectedFcuUnit ? this.selectedFcuUnit.index : this.fcuUnitList.length + 1,
            network: {
                A: {
                    LineAIp: this.fcuALineAIp,
                    LineBIp: this.fcuALineBIp,
                    fieldNetLineAIp: this.fcuAFieldNetLineAIp,
                    fieldNetLineBIp: this.fcuAFieldNetLineBIp,
                    ceuCommLineAIp: this.fcuACeuCommLineAIp,
                    ceuCommLineBIp: this.fcuACeuCommLineBIp,
                },
                B: {
                    LineAIp: this.fcuBLineAIp,
                    LineBIp: this.fcuBLineBIp,
                    fieldNetLineAIp: this.fcuBFieldNetLineAIp,
                    fieldNetLineBIp: this.fcuBFieldNetLineBIp,
                    ceuCommLineAIp: this.fcuBCeuCommLineAIp,
                    ceuCommLineBIp: this.fcuBCeuCommLineBIp,
                },
                Multicasting: {
                    LineAIp: multicastingAIp,
                    LineBIp: multicastingBIp,
                },
            },
        };
    }

    createFuUnitsPayload(fcuUnitId: string) {
        return this.fuList.map(fu => ({
            id: fu.id,
            fcuId: fcuUnitId,
            vesselId: fu.vesselId,
            index: fu.index,
            location: fu.location,
            fieldNetLineAIp: fu.fieldNetLineAIp,
            fieldNetLineBIp: fu.fieldNetLineBIp,
            communicationType: fu.communicationType,
        }));
    }

    createSlotsPayload(fcuUnitId: string, fuUnitList: FuUnit[]) {
        return [
            ...this.transformSlotListForDb(this.slotList, fcuUnitId),
            ...this.fuList.reduce((prev, fu) => {
                const findFuUnit = fuUnitList.find(newFu => newFu.index === fu.index);
                if (findFuUnit?.id)
                    prev = prev.concat(this.transformSlotListForDb(fu.slotList, fcuUnitId, findFuUnit.id));
                return prev;
            }, []),
        ];
    }

    createExtCommPayload(fcuUnitId: string) {
        return {
            id: this.externalCommunication.id,
            Ports: this.externalCommunication.Ports ? this.externalCommunication.Ports : [],
            index: 1,
            fcuId: fcuUnitId,
            vesselId: this.vessel.id,
        };
    }

    createCeuUnitsPayload(fcuUnitId: string) {
        return this.ceuList.map(ceu => ({
            ...ceu,
            fcuId: fcuUnitId,
            vesselId: this.vessel.id,
        }));
    }

    transformSlotListForDb(slotList: Slot[], fcuId: string, fuId: string = null): Slot[] {
        return slotList.map(slot => ({
            ...slot,
            vesselId: this.vessel.id,
            fcuId: fcuId || '',
            fuId: fuId || null,
            ioType: slot.ioType == this.EMPTY_SLOT || !slot.ioType ? this.EMPTY_VALUE : slot.ioType,
        }));
    }

    async selectSlotOption(event: { name: string; value: SlotOptionType }) {
        const { name, value } = event;

        const match = name.match(/\d+$/);
        const lastNumber = match ? Number(match[0]) : null;

        const fcuNumber = this.selectedFcuUnit?.index ? this.selectedFcuUnit?.index : this.fcuUnitList.length + 1;

        const dialogRef = this.dialog.open(SlotDialogComponent, {
            data: {
                title: `FCU ${fcuNumber}`,
                ioType: event.value,
                terminal: [],
            },
            disableClose: true,
        });

        const dialogResult = await firstValueFrom(dialogRef.afterClosed());

        if (!dialogResult) {
            return;
        }
        const newSlot: Slot = {
            ...this.slotList[lastNumber - 1],
            ...dialogResult,
            ioType: value,
            enable: true,
        };

        this.slotList.splice(lastNumber - 1, 1, newSlot);
        return;
    }

    async openExternalCommunicationDialog() {
        return;
        this.isOpenOption = false;
        const dialogRef = this.dialog.open(ExternalCommunicationDialogComponent, {
            data: {
                fcuIndex: this.selectedFcuUnit?.index ? this.selectedFcuUnit?.index : this.fcuUnitList.length + 1,
                externalCommunication: this.externalCommunication,
                ceuList: this.ceuList,
            },
            disableClose: true,
        });

        const dialogResult = await firstValueFrom(dialogRef.afterClosed());

        if (dialogResult) {
            this.externalCommunication = {
                ...this.externalCommunication,
                ...dialogResult.externalCommunication,
            };
            this.ceuList = [...dialogResult.ceuList];
        }
    }

    checkInputErrors() {
        const fcuUnitErrors = getValidationErrors(fcuUnitValidator(), {
            location: this.location,
            index: this.fcuUnitList.length + 1,
        });
        const fcuANetWorkErrors = getValidationErrors(fcuUnitNetWorkValidator(), {
            LineAIp: this.fcuALineAIp || null,
            LineBIp: this.fcuALineBIp || null,
            fieldNetLineAIp: this.fcuAFieldNetLineAIp || null,
            fieldNetLineBIp: this.fcuAFieldNetLineBIp || null,
            ceuCommLineAIp: this.fcuACeuCommLineAIp || null,
            ceuCommLineBIp: this.fcuACeuCommLineBIp || null,
        });
        const fcuBNetWorkErrors = getValidationErrors(fcuUnitNetWorkValidator(), {
            LineAIp: this.fcuBLineAIp || null,
            LineBIp: this.fcuBLineBIp || null,
            fieldNetLineAIp: this.fcuBFieldNetLineAIp || null,
            fieldNetLineBIp: this.fcuBFieldNetLineBIp || null,
            ceuCommLineAIp: this.fcuBCeuCommLineAIp || null,
            ceuCommLineBIp: this.fcuBCeuCommLineBIp || null,
        });

        const prefixedFcuAErrors = addPrefixToErrors(fcuANetWorkErrors, 'A');
        const prefixedFcuBErrors = addPrefixToErrors(fcuBNetWorkErrors, 'B');

        let errors = [...fcuUnitErrors, ...prefixedFcuAErrors, ...prefixedFcuBErrors];
        this.validationErrors = mapErrors(errors);
    }

    getIPErrors() {
        if (this.validationErrors) {
            const count = Object.values(this.validationErrors).filter((e: any) =>
                e?.errors?.includes('errors.validation.generic.ip-address-not-valid')
            ).length;
            return count;
        } else return 0;
    }

    toggleError() {
        this.errorMessageVisible = !this.errorMessageVisible;
    }

    disabledButton() {
        const hasFuErrors = this.fuList.some(fu => !!Object.keys(fu?.validationErrors || {}).find(key => key !== ''));
        const hasRootErrors = !!Object.keys(this.validationErrors).length;

        return !this.checkChanges() || hasRootErrors || hasFuErrors;
    }

    openMoreOption() {
        this.isOpenOption = !this.isOpenOption;
    }

    changeFuData(fuData) {
        const fuUnitErrors = getValidationErrors(fuUnitValidator(), fuData);

        const fuUnitMapErrors = mapErrors(fuUnitErrors);

        this.fuList[fuData.index - 1] = {
            ...this.fuList[fuData.index - 1],
            ...fuData,
            validationErrors: fuUnitMapErrors,
        };
    }

    addFuUnit() {
        const index = this.fuList.length + 1;

        this.fuList = this.fuList.concat({
            id: '',
            fcuId: '',
            vesselId: this.vessel.id,
            location: '',
            index: this.fuList.length + 1,
            communicationType: communicationTypes.serial,
            fieldNetLineAIp: '',
            fieldNetLineBIp: '',
            slotList: defaultSlotList,
            validationErrors: {},
        });
        this.showMessageDialog('system-settings.fu.message-dialog.create.message', {
            index: index,
        });
    }

    copyFuUnit(fuData) {
        const prevIndex = fuData.index;
        const copiedIndex = this.fuList.length + 1;

        this.fuList = this.fuList.concat({
            id: '',
            fcuId: '',
            vesselId: this.vessel.id,
            location: fuData.location,
            index: this.fuList.length + 1,
            communicationType: fuData.communicationType,
            fieldNetLineAIp: fuData.fieldNetLineAIp,
            fieldNetLineBIp: fuData.fieldNetLineBIp,
            slotList: [
                ...fuData.slotList.map(slot => ({
                    id: '',
                    fuId: '',
                    fcuId: slot.fcuId,
                    ioType: slot.ioType,
                    no: slot.no,
                    terminal: slot.terminal,
                    vesselId: slot.vesselId,
                    enable: slot.enable,
                })),
            ],
            validationErrors: _.cloneDeep(fuData.validationErrors),
        });
        this.showMessageDialog('system-settings.fu.message-dialog.copy.message', {
            prevIndex: prevIndex,
            copiedIndex: copiedIndex,
        });
    }

    deleteFuUnit(fuIndex: number) {
        let indexToDelete = this.fuList.findIndex(fu => fu.index === fuIndex);
        if (indexToDelete !== -1) {
            this.fuList.splice(indexToDelete, 1);
            this.fuList = this.fuList.map((fuUnit, index) => {
                return {
                    ...fuUnit,
                    index: index + 1,
                };
            });
        }
        this.showMessageDialog('system-settings.fu.message-dialog.delete.message', {
            index: fuIndex,
        });
    }

    clearFuUnit(index) {
        this.fuList[index - 1] = {
            id: '',
            fcuId: '',
            vesselId: this.vessel.id,
            location: '',
            index: index,
            communicationType: communicationTypes.serial,
            fieldNetLineAIp: '',
            fieldNetLineBIp: '',
            slotList: defaultSlotList,
            validationErrors: {},
        };
    }

    trackByFu(index: number, fu: any): any {
        return fu.index ?? index;
    }

    clear() {
        const fuList = structuredClone(this.fuList);
        this.slotList = getFcuDefaultSlots(this.vessel.id);
        this.location = '';
        this.fcuALineAIp = '';
        this.fcuALineBIp = '';
        this.fcuAFieldNetLineAIp = '';
        this.fcuAFieldNetLineBIp = '';
        this.fcuACeuCommLineAIp = '';
        this.fcuACeuCommLineBIp = '';
        this.fcuBLineAIp = '';
        this.fcuBLineBIp = '';
        this.fcuBFieldNetLineAIp = '';
        this.fcuBFieldNetLineBIp = '';
        this.fcuBCeuCommLineAIp = '';
        this.fcuBCeuCommLineBIp = '';
        this.fuList = fuList;

        this.checkInputErrors();
        this.isOpenOption = false;
    }

    checkChanges() {
        return !_.isEqualWith(this.initState, this.buildComparableState());
    }

    showMessageDialog(message: string, params?: Record<string, any>) {
        this.messageDialogService.openMessage(message, params);
    }

    getEmptySlotLabel(slotNum) {
        const translationString = this.translateService.instant('system-settings.fcu.label.slot-empty');

        return translationString + ' ' + slotNum;
    }

    private updateContentHeight() {
        if (!this.sideMenuContainer) return;
        const containerPosition = this.sideMenuContainer.nativeElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const bottom = containerPosition.bottom;

        if (windowHeight > bottom) this.contentHeight = '100%';
        else this.contentHeight = 'unset';

        this.cdr.detectChanges();
    }
}
